import * as React from 'react';

const ChatHistory = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" {...props}>
        <path
            stroke="#7D61A7"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M28 8H4M9.333 16H4M9.333 24H4M16 24a6.667 6.667 0 0 0 12-4 6 6 0 0 0-6-6 6.42 6.42 0 0 0-4.547 1.88l-2.787 2.787"
        />
        <path stroke="#7D61A7" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M14.666 13.333v5.333h5.333" />
    </svg>
);
export default ChatHistory;
